module.exports = new __parcel__URL__("broken-china.1ecae915.jpg").toString();